import { useCallback } from 'react';
import type { BlockerFunction } from 'react-router';
import { useBlocker } from 'react-router';

export function useNavigateBlocker(shouldBlock: BlockerFunction | boolean) {
	const wrappedBlocker = useCallback<BlockerFunction>(
		(args) => {
			if (args.nextLocation.state?.noBlockNavigation) {
				return false;
			}

			return typeof shouldBlock === 'boolean' ? shouldBlock : shouldBlock(args);
		},
		[shouldBlock]
	);

	return useBlocker(wrappedBlocker);
}
